import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useCreateIncident = () => {
  const utils = trpc.useUtils();

  return trpc.incidents.create.useMutation({
    onSettled: () => {
      utils.incidents.myList.invalidate();
      utils.incidents.myUnresolvedCount.invalidate();
      // Managers viewing the org-wide list should see the new row too.
      utils.incidents.list.invalidate();
      // A live incident red-flags the service it names — or EVERY service of
      // its itinerary when it names none. That flag is derived from
      // `operations.list`, so without this the bells and the Notification modal
      // only caught up on a page reload. Same helper the red-flag mutation uses,
      // so both directions of the coin refresh identically.
      invalidateItemQueries(utils);
    },
  });
};
